module.exports = __webpack_public_path__ + "static/media/hanyangerica.7d61b46c.png";